import { Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { StyledBox, StyledTypography, StyledWrapper } from "./style";
import { useSelector } from "react-redux";

const NotFound = () => {
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);
  const isAdmin = profileDetails.user_type === "admin";
  const dashboardPath = isAdmin ? "/admin/dashboard" : "/dashboard";

  return (
    <StyledWrapper>
      <StyledBox>
        <StyledTypography>404</StyledTypography>
        <StyledTypography size="true">Page Not Found</StyledTypography>
        <Button>
          <Link to={dashboardPath}>Go Back Dashboard</Link>
        </Button>
      </StyledBox>
    </StyledWrapper>
  );
};

export default NotFound;
